import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { Users, MapPin, Utensils, Phone } from './Icons';
export function WhyUsSection() {
  return <section className="py-24 bg-warm-white" data-id="element-305">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-306">
        <FadeIn className="text-center mb-16" data-id="element-307">
          <h2 className="text-3xl md:text-4xl font-serif text-deep-brown mb-6" data-id="element-308">
            ¿Por qué confiar en nosotros?
          </h2>
          <p className="text-xl text-terracotta font-serif italic" data-id="element-309">
            Porque no prometemos lo que no podemos cumplir.
          </p>
        </FadeIn>

        <StaggerContainer className="space-y-8" data-id="element-310">
          <StaggerItem data-id="element-311">
            <div className="flex items-start gap-6" data-id="element-312">
              <div className="mt-1 bg-cream p-3 rounded-full text-olive" data-id="element-313">
                <Users size={24} data-id="element-314" />
              </div>
              <div data-id="element-315">
                <h3 className="text-xl font-medium text-deep-brown mb-2" data-id="element-316">
                  Emprendimiento Local
                </h3>
                <p className="text-brown-medium text-lg" data-id="element-317">
                  Somos un emprendimiento local, con nombre y apellido. No hay
                  intermediarios ni excusas delegadas.
                </p>
              </div>
            </div>
          </StaggerItem>

          <StaggerItem data-id="element-318">
            <div className="flex items-start gap-6" data-id="element-319">
              <div className="mt-1 bg-cream p-3 rounded-full text-olive" data-id="element-320">
                <MapPin size={24} data-id="element-321" />
              </div>
              <div data-id="element-322">
                <h3 className="text-xl font-medium text-deep-brown mb-2" data-id="element-323">
                  Ubicación Estratégica
                </h3>
                <p className="text-brown-medium text-lg" data-id="element-324">
                  Ubicados en Carrasco, Montevideo, lo que nos permite una
                  logística eficiente y puntual.
                </p>
              </div>
            </div>
          </StaggerItem>

          <StaggerItem data-id="element-325">
            <div className="flex items-start gap-6" data-id="element-326">
              <div className="mt-1 bg-cream p-3 rounded-full text-olive" data-id="element-327">
                <Utensils size={24} data-id="element-328" />
              </div>
              <div data-id="element-329">
                <h3 className="text-xl font-medium text-deep-brown mb-2" data-id="element-330">
                  Producción Propia
                </h3>
                <p className="text-brown-medium text-lg" data-id="element-331">
                  Cada pedido pasa por nuestras manos. Cada bandeja sale de
                  nuestra producción propia, garantizando calidad y frescura.
                </p>
              </div>
            </div>
          </StaggerItem>

          <StaggerItem data-id="element-332">
            <div className="flex items-start gap-6" data-id="element-333">
              <div className="mt-1 bg-cream p-3 rounded-full text-olive" data-id="element-334">
                <Phone size={24} data-id="element-335" />
              </div>
              <div data-id="element-336">
                <h3 className="text-xl font-medium text-deep-brown mb-2" data-id="element-337">
                  Comunicación Directa
                </h3>
                <p className="text-brown-medium text-lg" data-id="element-338">
                  Cada cliente que confía en nosotros sabe que puede llamarnos
                  directamente. Hay una persona real cuidando su evento.
                </p>
              </div>
            </div>
          </StaggerItem>
        </StaggerContainer>
      </div>
    </section>;
}